import * as React from "react";
//#region types
import { LoginViewProps } from "models/propTypes/loginPropTypes";
import { AuthEnums } from "models/enums";
//#endregion
//#region components
import CheckMail from "./checkMail";
import useLoginContext from "./context/useLoginContext";
import ForgotPassword from "./forgotPassword";
//#endregion

const ForgotPasswordContainer: React.FC<LoginViewProps> = (props) => {
  const { displayType } = props;
  const [isPasswordResetSuccess, setIsPasswordResetSuccess] = React.useState<boolean>(false);

  const onSubmitSuccess = () => {
    setIsPasswordResetSuccess(true);
  };

  const { setLoginView } = useLoginContext();

  const goToLoginForm = () => {
    setLoginView(AuthEnums.LoginView.UserNamePassword);
  };

  return isPasswordResetSuccess ? (
    <CheckMail displayType={displayType} goBack={goToLoginForm} />
  ) : (
    <ForgotPassword displayType={displayType} goBack={goToLoginForm} onSubmitSuccess={onSubmitSuccess} />
  );
};

export default ForgotPasswordContainer;
